import axios from "axios";
import router from "./../router";
import store from "./../vuex";
import * as types from "./../vuex/modules/app/mutation-type.js";
import NProgress from "nprogress";

// axios 配置
axios.defaults.timeout = 120000;
axios.defaults.baseURL = process.env.VUE_APP_API_ROOT;
axios.defaults.headers.post["Content-Type"] = "application/json";

// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (sessionStorage.token) {
      config.headers.token = `${sessionStorage.token}`;
    } else if (sessionStorage.mkYHTToken) {
      config.headers.token = `${sessionStorage.mkYHTToken}`;
    }
    NProgress.start();
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  response => {
    NProgress.done();
    return response;
  },
  error => {
    if (error.status) {
      switch (error.status) {
        case 401:
          // 401 清除token信息并跳转到登录页面
          store.commit(types.LOGOUT);
          router.replace({
            path: "login",
            query: {
              redirect: router.currentRoute.fullPath
            }
          });
          break;
      }
    }
    return Promise.reject(error);
    
  }
);

let http = {
  get: function(url, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(url, {
          params
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  post: function(url, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, data)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  put: function (url, data) {
    return new Promise((resolve, reject) => {
      axios.put(url, data)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          // reject(error) 
        })
    })
  },
  delete: function (url, params) {
    return new Promise((resolve, reject) => {
      axios.delete(url, {
        params
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          // reject(error)
        })
    })
  }
};

export default http;
